var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row col-12 col-md-8 d-flex justify-content-center justify-content-md-start pl-md-0 mt-3 mt-md-0 pr-under-md-0 pl-under-md-0"
    },
    [
      _c("div", { staticClass: "col-12 pl-0 pr-0 mb-1" }, [
        _c(
          "div",
          { staticClass: "styled-scrollbar-custom" },
          [
            _c("div", { staticClass: "fake-card-container mb-4" }, [
              _c("div", { staticClass: "fake-card-image-container" }, [
                _c("img", {
                  staticClass: "fake-card-image",
                  attrs: {
                    src: require("@/assets/images/b122/fakeAnnonceImage.jpeg"),
                    alt: "Veilleur"
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "fake-card-values" }, [
                _c("div", [
                  _c(
                    "div",
                    _vm._l(5, function(index) {
                      return _c("i", { staticClass: "ph-star-fill main-color" })
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "fake-card-title w-75" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fake-card-title w-50" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fake-card-content w-25 mt-2" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "fake-card-content w-50" })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "fake-card-views" })
              ])
            ]),
            _vm._v(" "),
            _vm._l(Object.entries(_vm.options), function(ref) {
              var key = ref[0]
              var value = ref[1]
              return _c(
                "div",
                {
                  key: key,
                  class:
                    "reward-boost-option-container mt-2 " +
                    (value.disabled ? " reward-boost-option-disabled" : ""),
                  on: {
                    click: function($event) {
                      return _vm.changeSelectedOption(value)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row" },
                    [
                      _c("b-form-radio", {
                        attrs: { disabled: value.disabled, value: value },
                        nativeOn: {
                          click: function($event) {
                            $event.stopPropagation()
                          }
                        },
                        model: {
                          value: _vm.selectedOption,
                          callback: function($$v) {
                            _vm.selectedOption = $$v
                          },
                          expression: "selectedOption"
                        }
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _vm._v(
                          _vm._s(
                            key +
                              " " +
                              (key > 1 ? _vm.$t("stars") : _vm.$t("star"))
                          )
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !value.disabled
                    ? _c("div", { staticClass: "reward-boost-option-price" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              (!_vm.fromAnnonceCreation ? "+" : "") +
                                (value.customAmount
                                  ? _vm.$t("free")
                                  : value.price + "€")
                            ) +
                            "\n        "
                        )
                      ])
                    : _vm._e()
                ]
              )
            }),
            _vm._v(" "),
            _vm.selectedOption && _vm.selectedOption.customAmount
              ? _c(
                  "div",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          "invalid-feedback":
                            _vm.annonce.additionnalRewardAmount.invalidFeedback
                        }
                      },
                      [
                        _c(
                          "b-input-group",
                          [
                            _c("b-form-input", {
                              ref: "customAmountInput",
                              staticClass: "border-right-0",
                              attrs: {
                                id: "customAmountInput",
                                formatter: _vm.formatCustomAmount,
                                "invalid-feedback":
                                  _vm.annonce.additionnalRewardAmount
                                    .invalidFeedback,
                                min: _vm.options[5].price,
                                state:
                                  _vm.annonce.additionnalRewardAmount.state,
                                lazy: "",
                                "lazy-formatter": "",
                                type: "number"
                              },
                              model: {
                                value: _vm.customAmount,
                                callback: function($$v) {
                                  _vm.customAmount = $$v
                                },
                                expression: "customAmount"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "b-input-group-append",
                              [
                                _c(
                                  "b-input-group-text",
                                  {
                                    staticClass:
                                      "reward-boost-option-custom-amount-suffix"
                                  },
                                  [
                                    _vm._v(
                                      "\n                €\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.annonce.additionnalRewardAmount.state
                      ? _c(
                          "b-form-invalid-feedback",
                          { staticClass: "mb-2 d-flex" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.annonce.additionnalRewardAmount
                                    .invalidFeedback
                                ) +
                                "\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal",
          staticClass: "additional-reward-info-modal",
          attrs: {
            id: "additional-reward-info-modal",
            centered: "",
            "hide-footer": "",
            "hide-header": ""
          }
        },
        [
          _c("div", [
            _c("p", {
              staticClass:
                "page-title additional-reward-info-modal-title mt-0 mb-3",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("additional.reward.know.more.modal.title")
                )
              }
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "vin-info-text mt-2",
              domProps: {
                innerHTML: _vm._s(
                  _vm.$t("additional.reward.know.more.modal.description")
                )
              }
            })
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cfc04c50", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cfc04c50","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/annonce/AnnonceCreate/AnnonceCreateAdditionalRewardStep.vue
// module id = iPeG
// module chunks = 0